export interface WeekRange {
  start: number;
  end: number;
}

const WEEK_RANGE_PATTERN = /^(\d+)(?:-(\d+))?$/;

export const parseWeekRange = (
  week: string | number | null | undefined
): WeekRange | null => {
  if (week === null || week === undefined || week === "") {
    return null;
  }

  const match = String(week).match(WEEK_RANGE_PATTERN);
  if (!match) {
    return null;
  }

  const start = Number(match[1]);
  const end = match[2] !== undefined ? Number(match[2]) : start;

  if (start > end) {
    return null;
  }

  return { start, end };
};

export const weekRangesOverlap = (
  a: string | null | undefined,
  b: string | null | undefined
): boolean => {
  const rangeA = parseWeekRange(a);
  const rangeB = parseWeekRange(b);

  if (!rangeA || !rangeB) {
    return false;
  }

  return rangeA.start <= rangeB.end && rangeB.start <= rangeA.end;
};
